/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Audience_Imagealt1Inputs */

const zh_landing_audience_imagealt1 = /** @type {(inputs: Landing_Audience_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`老师正在白板前给学生反馈`)
};

const en_landing_audience_imagealt1 = /** @type {(inputs: Landing_Audience_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teacher giving feedback to a student at a whiteboard`)
};

const es_landing_audience_imagealt1 = /** @type {(inputs: Landing_Audience_Imagealt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una profesora dando retroalimentación a un estudiante junto a una pizarra`)
};

/**
* | output |
* | --- |
* | "Teacher giving feedback to a student at a whiteboard" |
*
* @param {Landing_Audience_Imagealt1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_audience_imagealt1 = /** @type {((inputs?: Landing_Audience_Imagealt1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Audience_Imagealt1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_audience_imagealt1(inputs)
	if (locale === "en") return en_landing_audience_imagealt1(inputs)
	return es_landing_audience_imagealt1(inputs)
});
export { landing_audience_imagealt1 as "landing_audience_imageAlt" }